/** Playback speeds offered by the article audio player. Shared by `useSpeech` and the player markup. */
export const SPEED_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2];
